import React from 'react';
import { Layout, SettingToggle, TextStyle } from "@shopify/polaris";

export default function StatusSection(props) {
    return  (
        <Layout.AnnotatedSection
            title="Status"
        >
            <span id="sab_status_section"></span>

            <SettingToggle
                action={{
                    content: props.shopData.status ? 'Disable' : 'Enable',
                    onAction: props.toggleStatus,
                }}
                enabled={props.shopData.status}
                >
                {props.shopData.status ? (
                    <span>The app is <TextStyle variation="strong">enabled</TextStyle> and the announcement bar will be shown on your store.</span>
                ) : (
                    <span>The app is <TextStyle variation="strong">disabled</TextStyle> and the announcement bar won't be shown on your store.</span>
                )}
            </SettingToggle>
        </Layout.AnnotatedSection>
    )
}